export default "__VITE_ASSET__CeLcNFHr__"